import { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { addFoliosRange } from '../../services/Configs/ItemFolios'

function AddItemFolioModal({ show, handleClose, handleReload }) {
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    const prefix = 'Nn-';

    const total = (() => {
        const s = Number(start), e = Number(end);
        return Number.isFinite(s) && Number.isFinite(e) && e >= s ? (e - s + 1) : 0;
    })();

    const onSave = () => {
        const s = Number(start), e = Number(end);
        const pending = [];
        if (!Number.isInteger(s)) pending.push('Número inicial');
        if (!Number.isInteger(e)) pending.push('Número final');
        if (pending.length) return toast.warning(`Completa: ${pending.join(', ')}`);
        if (e < s) return toast.warning('El número final debe ser mayor o igual al inicial');
        addFoliosRange(s, e, prefix, true).then(r => {
            if (r?.ok) {
                toast.success(`Se solicitaron ${total} folios`);
                handleClose();
                handleReload();
            } else {
                toast.error(r?.message || 'No se pudo crear el rango');
            }
        });
    };

    useEffect(() => { if (show) { setStart(''); setEnd(''); } }, [show]);

    return (
        <Modal size="sm" show={show} onHide={handleClose} backdrop="static">
            <Modal.Header closeButton><Modal.Title>Agregar Folio</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form.Label>Número Inicial:</Form.Label>
                <Form.Control value={start} onChange={e => setStart(e.target.value.replace(/\D/g, ''))} />
                <Form.Label className="mt-2">Número Final:</Form.Label>
                <Form.Control value={end} onChange={e => setEnd(e.target.value.replace(/\D/g, ''))} />
                <Form.Label className="mt-2">Total de registros:</Form.Label>
                <Form.Control value={total} readOnly />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={onSave} disabled={total <= 0}>Guardar</Button>
                <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddItemFolioModal;